import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { applyTheme, getEmbedTheme } from '../utils/embed';
import { postToHost, listenFromHost, MSG } from '../utils/embedMessages';
import { PageMetaProvider } from '../hooks/usePageMeta';
import { DocumentTitle } from './DocumentTitle';

/**
 * G5-T34.5: Embed mod layout — NavMenu olmadan sade içerik.
 * G5-T34.4: postMessage ile host navigasyon + tema komutlarını dinler.
 */
export function EmbedLayout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // İlk yüklemede temayı uygula
    applyTheme(getEmbedTheme());

    // Host'a hazır olduğumuzu bildir
    postToHost(MSG.READY);

    // Host'tan gelen mesajları dinle
    const unlisten = listenFromHost((msg) => {
      if (msg.type === MSG.NAVIGATE && msg.path) {
        navigate(msg.path);
      } else if (msg.type === MSG.SET_THEME && msg.theme) {
        applyTheme(msg.theme);
      }
    });

    return unlisten;
  }, [navigate]);

  // Sayfa değişince host'a bildir
  useEffect(() => {
    postToHost(MSG.NAVIGATE, { path: location.pathname });
  }, [location.pathname]);

  // Yükseklik değişimlerini host'a bildir
  useEffect(() => {
    const observer = new ResizeObserver(() => {
      postToHost(MSG.RESIZE, { height: document.body.scrollHeight });
    });
    observer.observe(document.body);
    return () => observer.disconnect();
  }, []);

  // PageMetaProvider + DocumentTitle: embed penceresi Layout'un dışında kaldığı için pencere
  // başlığı index.html'deki "SalesOps"ta kalıyordu. Sabit raporlar ayrı pencerede açıldığından
  // hangi raporun açık olduğu başlıkta görünsün diye burada da asılır; sayfa meta'sı menüyü
  // yener (bkz. DocumentTitle preferPageTitle).
  return (
    <PageMetaProvider>
      <div className="embed-layout" style={{ padding: '0', margin: '0' }}>
        <DocumentTitle preferPageTitle />
        {children}
      </div>
    </PageMetaProvider>
  );
}
